module.exports = __webpack_public_path__ + "fb343314e2836c883acc883900723994.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/login/img/premio-br-week-es.png
// module id = 1239
// module chunks = 0